module.exports = __webpack_public_path__ + "img/pdf-brander-2.270a0a5c.png";